import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AssistantChatApi, AssistantChatApiImpl } from '@/presentation/pages/assistant/apis';
import { NoveltyCheckSearchApi, NoveltyCheckSearchApiImpl } from './apis';
import {
    NoveltyExampleService,
    NoveltyExampleServiceImpl,
} from './services/novelty-example-service';

export const noveltyCheckSearchContainer = new ContainerModule((bind) => {
    bind(AssistantChatApi).to(AssistantChatApiImpl);
    bind(NoveltyCheckSearchApi).to(NoveltyCheckSearchApiImpl);
    bind(NoveltyExampleService).to(NoveltyExampleServiceImpl);
});
